module.exports = __webpack_public_path__ + "img/syzxc01.e733b4ff.png";